import { useDispatch, useSelector } from "react-redux";
import { Link, useMatches, useNavigate } from "react-router-dom";
import { setPlatformTypeReducer } from "../../store/slice/platformTypeSlice";
import {
  fetchRepresentManualPath,
  MANUAL_TYPE,
  PLATFORM_TYPE,
} from "../../util/platformNavigation";
import "./Header.scss";

const Header = () => {
  const navigate = useNavigate();
  const routeData = useMatches().find((match) => match.data?.manualType)?.data;
  // const jwtToken = useSelector((state) => state.loginChecker.jwtToken);
  const manualType =
    useSelector((state) => state.manualTypeChecker.manualType) ||
    routeData?.manualType;
  const platformType =
    useSelector((state) => state.platformTypeChecker.platformType) ||
    routeData?.platformType;
  const dispatch = useDispatch();

  const handlePlatformType = async (event) => {
    const toPlatformType = event.target.id;
    if (platformType === toPlatformType) return;
    dispatch(setPlatformTypeReducer({ platformType: toPlatformType }));

    const targetPlatformType =
      toPlatformType === "kcp" ? PLATFORM_TYPE.KCP : PLATFORM_TYPE.LEGACY;
    const representPath = await fetchRepresentManualPath(
      MANUAL_TYPE.G,
      targetPlatformType,
    );
    navigate(
      representPath ??
        (toPlatformType === "kcp" ? "/g/kcp/no-index" : "/g/no-index"),
    );
  };

  // const switchManualType = () => {
  //   // navigate(manualType == "kt" ? "g" : "kt");
  //   console.log(manualType);
  //   console.log(manualType == "kt" ? "/g" : "/kt");
  //   console.log("navigate to another manual type");
  // };
  const linkPath = !manualType
    ? "/kt/"
    : manualType === "g" && platformType === "kcp"
      ? `/${manualType}/${platformType}/`
      : `/${manualType}/`;

  return (
    <div id="header-area">
      <div className="header-logo">
        <Link className="logo-image" to={linkPath}>
          <img
            id="logo-image-tag"
            src="/assets/KT_CLOUD_LOGO_WHITE.png"
            alt="로고"
          />
        </Link>
        {manualType === "kt" ? (
          <span className="logo-text-kt">매뉴얼</span>
        ) : (
          <span className="logo-text-g">공공 클라우드 매뉴얼</span>
        )}
      </div>
      <div className="gnb"></div>
      {manualType === "g" && (
        <div className="platform-switch">
          <div className="platform-switch-form">
            <button
              className={`platform-switch-input left${
                platformType === "kcp" ? " checked-kcp" : ""
              }`}
              name="platform-radio"
              id="kcp"
              onClick={(event) => handlePlatformType(event)}
            >
              kt cloud PLATFORM
            </button>
            <button
              className={`platform-switch-input right${
                platformType === "legacy" ? " checked-legacy" : ""
              }`}
              name="platform-radio"
              id="legacy"
              onClick={(event) => handlePlatformType(event)}
            >
              Classic
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
